import type { ReactNode } from 'react'
import { AlertTriangle, Check, Info } from 'lucide-react'
import type { SelectOption } from '../../../admin/primitives.js'
import type { SalleRegistre } from './modele.js'
import { SALLES_CLUB, nomSalle } from '../salles.js'

/**
 * REGISTRE — petites pièces partagées par les onglets (21/10/2026).
 * Un retour d'action dit la conséquence d'abord ; un état vide dit POURQUOI
 * et où aller ; jamais une fausse donnée.
 */

export type Retour = { ton: 'ok' | 'ko' | 'info'; texte: string } | null

export function LigneRetour({ retour }: { retour: Retour }) {
  if (!retour) return null
  const Icone = retour.ton === 'ok' ? Check : retour.ton === 'ko' ? AlertTriangle : Info
  return (
    <p className={`sv-rgs-retour sv-rgs-retour--${retour.ton}`} role={retour.ton === 'ko' ? 'alert' : 'status'}>
      <Icone size={15} aria-hidden="true" /> <span>{retour.texte}</span>
    </p>
  )
}

export function Vide({ titre, children }: { titre: string; children?: ReactNode }) {
  return (
    <div className="sv-rgs-vide" role="status">
      <p className="sv-rgs-vide__titre">{titre}</p>
      {children ? <div className="sv-rgs-vide__texte">{children}</div> : null}
    </div>
  )
}

/** Options d'une salle : « Sans salle » puis les salles de Sonde ; une salle suggérée inconnue reste choisissable. */
export function optionsSalles(salles: SalleRegistre[] | null, enPlus: (string | null)[] = []): SelectOption[] {
  const connues = [...(salles ?? [])].sort((a, b) => a.sort_order - b.sort_order || a.code.localeCompare(b.code))
  const codes = new Set(connues.map((s) => s.code))
  const autres = [...new Set(enPlus.filter((c): c is string => !!c && !codes.has(c)))]
  return [
    { value: '', label: 'Sans salle' },
    ...connues.map((s) => {
      const nom = nomSalle(s.code, s.label)
      return { value: s.code, label: SALLES_CLUB[s.code] || nom === s.code ? nom : `${nom} (${s.code})` }
    }),
    ...autres.map((c) => ({ value: c, label: `${c} (salle suggérée)` })),
  ]
}

export function libelleSalle(salles: SalleRegistre[] | null, code: string | null): string {
  if (!code) return 'Sans salle'
  // ROOM 1, ROOM 2, ROOM 3 : jamais les anciens libellés de Sonde ni le code nu.
  return nomSalle(code, salles?.find((x) => x.code === code)?.label ?? null)
}
